import { AxiosRequestConfig, AxiosResponse } from 'axios'
import instance from './AxiosInstance';

instance.defaults.baseURL = process.env.REACT_APP_API_URL;
instance.defaults.headers.common['Content-Type'] = 'application/json';

class HTTPClient {
    setBaseUrl(url: string) {
        instance.defaults.baseURL = url;
    }

    async get(path: string): Promise<AxiosResponse> {
        const response: AxiosResponse = await instance.get(path);
        return response;
    }

    async post(path: string, body: any, headers: Record<string, string> = {}): Promise<AxiosResponse> {
        const config: AxiosRequestConfig = { headers: headers }
        const response: AxiosResponse = await instance.post(path, body, config);

        return response;
    }

    async put(path: string, body: any, headers: Record<string, string> = {}): Promise<AxiosResponse> {
        const config: AxiosRequestConfig = { headers: headers }
        const response: AxiosResponse = await instance.put(path, body, config);
        return response;
    }

    async delete(path: string): Promise<AxiosResponse> {
        const response: AxiosResponse = await instance.delete(path);
        return response;
    }

    async download(path: string) {
        let headers: AxiosRequestConfig = {};
        headers.responseType = 'blob';
        const response: AxiosResponse = await instance.get(path, headers)

        const url = window.URL.createObjectURL(new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers["content-disposition"]!.split("filename=")[1].split(';')[0]);
        document.body.appendChild(link);
        link.click();
    }
}

const httpClient = new HTTPClient();
export default httpClient;
